import logoSvg from "../../assets/logo.svg";

export function TopNavBar() {
  return (
    <header className="liquid-glass sticky top-0 z-40 border-b border-ink-200/70 bg-white/80">
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between px-6">
        <a className="flex items-center" href="/">
          <img alt="スカウトメールAI" className="h-7" src={logoSvg} />
        </a>
        <nav className="hidden items-center gap-8 text-[14px] text-ink-700 md:flex">
          <a className="hover:text-ink-900" href="#flow">
            機能
          </a>
          <a className="hover:text-ink-900" href="#pricing">
            料金
          </a>
          <a className="hover:text-ink-900" href="#cases">
            導入事例
          </a>
          <a className="hover:text-ink-900" href="#resources">
            リソース
          </a>
        </nav>
        <div className="flex items-center gap-2">
          <a
            className="hidden h-10 items-center rounded-lg border border-ink-200 px-4 text-[13px] font-medium text-ink-800 hover:bg-ink-50 sm:inline-flex"
            href="/admin/login"
          >
            ログイン
          </a>
          <a
            className="btn-primary inline-flex h-10 items-center rounded-lg px-4 text-[13px] font-semibold text-white"
            href="#cta"
          >
            無料で始める
          </a>
        </div>
      </div>
    </header>
  );
}
